<script setup lang="ts">
import { useSnackbar } from '@/composables/useSnackbar'

const { state, hide } = useSnackbar()
</script>

<template>
  <v-snackbar v-model="state.visible" :color="state.color" :timeout="state.timeout" location="bottom right" multi-line>
    {{ state.message }}

    <template v-slot:actions>
      <v-btn color="white" variant="text" @click="hide"> Close </v-btn>
    </template>
  </v-snackbar>
</template>
